import { render, staticRenderFns } from "./telegram-bot_page.vue?vue&type=template&id=5b6a0fe0&scoped=true"
import script from "./telegram-bot_page.vue?vue&type=script&lang=js"
export * from "./telegram-bot_page.vue?vue&type=script&lang=js"
import style0 from "./telegram-bot_page.vue?vue&type=style&index=0&id=5b6a0fe0&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6a0fe0",
  null
  
)

export default component.exports